import { useWallets } from '@/devtools/hooks/useWallets.hook';
import { useEffect } from 'react';
import { useStore } from 'store/store';

interface UseWalletProps {
  noSave?: boolean;
}

export const useWallet = (props?: UseWalletProps) => {
  const store = useStore();
  const query = useWallets({ enabled: false, noSave: props?.noSave });

  useEffect(() => {
    query.wallets.refetch();
  }, []);

  useEffect(() => {
    if (props?.noSave) return;
    if (!query.wallets.data?.data) return;
    store.changeWallets(query.wallets.data.data);
  }, [query.wallets.data]);

  const getWalletByAsset = (asset: string, accountLabel: string) => {
    const wallet = query.wallets.data?.data.find((wallet) => wallet.asset === asset);
    if (!wallet) return undefined;
    const account = wallet.wallets.find((account) => (account.accountLabel = accountLabel));
    return account;
  };

  const getWalletById = (asset: string, id?: string) => {
    if (!id) return undefined;
    const wallet = query.wallets.data?.data.find((wallet) => wallet.asset === asset);
    if (!wallet) return undefined;
    const account = wallet.wallets.find((account) => account.id === id);
    return account;
  };

  return { getWalletById, getWalletByAsset, query };
};
